import { Button } from '@syncanix/ui';
import { Link } from 'react-router-dom';

import { useT } from '@/core/providers/I18nProvider';

import type { ReactElement } from 'react';

export function NotFoundPage(): ReactElement {
  const { t } = useT();
  return (
    <main className="flex min-h-screen items-center justify-center p-6">
      <section className="max-w-md space-y-4 text-center">
        <h1 className="text-h1">{t('notfound.heading')}</h1>
        <p className="text-muted-foreground">{t('notfound.description')}</p>
        {/* The 404 page renders OUTSIDE the AuthGuard/AppShell, so the recovery
            link points at the `/` front door (RootRedirect), which routes to
            `/home` for a signed-in user and `/signin` for an anonymous one. A
            direct `/home` would bounce an anonymous visitor through the guard to
            `/signin` — a surprising redirect from a "back to start" CTA. */}
        <Button asChild>
          <Link to="/">{t('notfound.backToStart')}</Link>
        </Button>
      </section>
    </main>
  );
}
